export default __webpack_public_path__ + "static/media/add.7b762f42.svg";